// Framework
import { Component, Input, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Router } from "@angular/router";
import { Subscription } from "rxjs";
import { finalize, mergeMap } from "rxjs/operators";
// Classes
import { Organization } from "@src/app/modules/share/classes/organization.class";
// Services
import { AppSettingsService } from "@src/app/modules/share/services/app-settings.service";
import { SessionApiService } from "@src/app/modules/login-module/services/api/session-api.service";
import { FeatureGroupSettingsService } from "@src/app/modules/share/services/feature-group-settings.service";
import { OrganizationApiService } from "@src/app/modules/share/services/api/organization-api.service";

@Component({
    selector: "app-header",
    templateUrl: "./header.component.html",
    styleUrls: ["./header.component.scss"]
})
export class HeaderComponent implements OnInit {
    private subscription = new Subscription();
    @Input() displaySessionIcons = false;
    isLoggedIn = false;
    organizationsArray: Organization[] = [];

    get currentLang(): string {
        return this.translate.currentLang;
    }

    get isProfileActive(): boolean {
        if (this.router.isActive("/profile/profile-editor", true)) {
            return true;
        } else {
            return false;
        }
    }

    get hasMultipleOrganizations(): boolean {
        return this.organizationsArray.length > 1;
    }

    constructor(
        private translate: TranslateService,
        private router: Router,
        public appSettings: AppSettingsService,
        private sessionApi: SessionApiService,
        public featureGroupSettings: FeatureGroupSettingsService,
        private organizationApi: OrganizationApiService,
    ) { }

    ngOnInit(): void {
        this.subscription.add(this.appSettings.getIsLoggedInAsObservable()
            .pipe(
                mergeMap((value) => {
                    this.isLoggedIn = value;

                    return this.organizationApi.getAllOrganizations();
                }),
            )
            .subscribe(
                (allOrganizations) => {
                    this.organizationsArray = allOrganizations;
                },
                (err) => {
                    console.error(err);
                }
            )
        );
    }

    /**
     * This method changes the language of the site
     * @param language language to be changed
     */
    onUseLanguageClicked(language: string): void {
        this.translate.use(language);
    }

    /**
     * This method either terminates the current session or navigates the user to the login page.
     */
    onSessionTogglerClicked(): void {
        if (this.isLoggedIn === true) {
            this.subscription.add(this.sessionApi.deleteSession()
                .pipe(
                    finalize(() => {
                        this.appSettings.setIsLoggedIn(false);
                        this.appSettings.clearCookieData();
                        this.router.navigate(["session", "login"]).catch((err) => {
                            console.error(err);
                        });
                    })
                )
                .subscribe(
                    () => { },
                    (err) => {
                        console.error(err);
                    }
                )
            );
        } else {
            this.router.navigate(["session", "login"]).catch((err) => {
                console.error(err);
            });
        }
    }
}
